type Props = {
  heading: string;
  icon: string;
  headingAdditionalClasses?: string;
  iconAdditionalClasses?: string;
};

function FormHeadingWithIcon(props: Props) {
  const { icon, heading, headingAdditionalClasses, iconAdditionalClasses = "" } = props;
  return (
    <div className="flex items-center">
      <img src={icon} className={`mr-2 ${iconAdditionalClasses}`} alt={`${heading}_icon_alt`} />
      <h1 className={`text-xl font-semibold text-white ${headingAdditionalClasses}`}>{heading}</h1>
    </div>
  );
}

export default FormHeadingWithIcon;

FormHeadingWithIcon.defaultProps = {
  headingAdditionalClasses: "",
};
